import { HttpClient } from '@angular/common/http';
import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { Observable } from 'rxjs';
import {
  CreateWalletSessionRequest,
  CreateWalletSessionResponse,
  GetWalletSessionResponse,
} from '../models/wallet-session.models';
import { WalletSessionService } from './wallet-session.service';

/* istanbul ignore next */
export class WalletSessionPlatformService extends WalletSessionService {
  private readonly baseUrl: string;

  constructor(
    private httpClient: HttpClient,
    appConfig: AppConfigSettings,
  ) {
    super();
    this.baseUrl = appConfig.getconfig('sessionServiceUrl');
  }

  createWalletSession(
    tenantId: string,
    request: CreateWalletSessionRequest,
  ): Observable<CreateWalletSessionResponse> {
    return this.httpClient.post<CreateWalletSessionResponse>(
      `${this.baseUrl}/v1/tenants/${tenantId}/wallet-session`,
      request,
    );
  }

  getWalletSession(
    tenantId: string,
    wSessionId: string,
  ): Observable<GetWalletSessionResponse> {
    return this.httpClient.get<GetWalletSessionResponse>(
      `${this.baseUrl}/v1/tenants/${tenantId}/wallet-session/${wSessionId}`,
    );
  }

  completeWalletSession(
    tenantId: string,
    wSessionId: string,
  ): Observable<void> {
    return this.httpClient.put<void>(
      `${this.baseUrl}/v1/tenants/${tenantId}/wallet-session/${wSessionId}/complete`,
      {},
    );
  }
}
